<template>
  <div>
  <v-toolbar flat color="white">
    <v-toolbar-title>Depósitos</v-toolbar-title>
    <v-divider
      class="mx-2"
      inset
      vertical
    ></v-divider>
    <v-spacer></v-spacer>
    <v-btn color="primary" dark class="mb-2" v-on:click="nuevoRegistro()">Ingresar depósito</v-btn>
    <v-dialog v-model="dialog" max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">Depósito</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex d-flex>
                <v-menu
                  ref="menu"
                  :close-on-content-click="false"
                  v-model="menu"
                  :nudge-right="40"
                  :return-value.sync="registro.depositoFecha"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="depositoFecha"
                    label="Fecha"
                    prepend-icon="event"
                    @blur="registro.depositoFecha = parseDate(depositoFecha)"
                    :messages="errores.depositoFecha.mensajes"
                    :error="errores.depositoFecha.error"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="registro.depositoFecha" locale='es-pe' @input="$refs.menu.save(registro.depositoFecha)" v-bind:readonly="disabledRegistro" scrollable></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex d-flex>
                <v-layout align-center>
                  <v-text-field label="Número" mask="####################" v-model="registro.depositoNumero" :messages="errores.depositoNumero.mensajes" :error="errores.depositoNumero.error" v-bind:readonly="disabledRegistro"></v-text-field>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex d-flex>
                <v-layout align-center>
                  <v-text-field label="Total" v-model="registro.depositoMonto" maxlenght=20 :messages="errores.depositoMonto.mensajes" :error="errores.depositoMonto.error" v-bind:readonly="disabledRegistro" v-money></v-text-field>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark @click.native="cerrar">Cerrar</v-btn>
          <v-btn color="success" dark @click.native="guardar(registro.registroId)" v-if="!disabledRegistro">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-toolbar>
  <v-data-table
    :headers="headers"
    :items="datos.data"
    :pagination.sync="pagination"
    :total-items="totalRegistros"
    :loading="loading"
    rows-per-page-text="Filas por página"
  >
    <template slot="items" slot-scope="props">
      <td>{{ props.item.fila[1] }}</td>
      <td class="">{{ props.item.fila[2] }}</td>
      <td class="">{{ props.item.fila[3] }}</td>
      <td class="justify-center layout px-0">
        <v-icon
          small
          class="mr-2"
          @click="verRegistro(props.item)"
        >
          open_in_browser
        </v-icon>
      </td>
    </template>
    <template slot="no-data">
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template>
  </v-data-table>
</div>
</template>

<script>
import mixin from '../mixins.js'
export default {
  mixins: [mixin],
  data: () => ({
    dialog: false,
    disabledRegistro: false,
    totalRegistros: 0,
    loading: false,
    pagination: {},
    menu: false,
    depositoFecha: null,
    headers: [
      {
        text: 'Fecha',
        align: 'left',
        value: 0
      },
      { text: 'Número', value: 1 },
      { text: 'Monto', value: 2 },
      { text: 'Actions', align: 'center', value: '', sortable: false }
    ],
    datos: [],
    registro: {},
    errores: {
      'depositoFecha': {mensajes: [], error: false},
      'depositoNumero': {mensajes: [], error: false},
      'depositoMonto': {mensajes: [], error: false}
    }
  }),
  computed: {
    computedDepositoFecha () {
      return this.formatoFecha(this.registro.depositoFecha)
    }
  },
  watch: {
    dialog (val) {
      val || this.cerrar()
    },
    'registro.depositoFecha' (val) {
      this.depositoFecha = this.formatoFecha(this.registro.depositoFecha)
    },
    pagination: {
      handler () {
        if (this.loading === false) {
          let descendente = 0
          if (this.pagination.descending) {
            descendente = 1
          }
          this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page)
        }
      },
      deep: true
    }
  },
  created () {
    this.initialize()
    this.pagination.rowsPerPage = 10
  },
  methods: {
    initialize () {
      this.datos = {}
    },
    apiListaRegistros (idx, ord, pagina) {
      var solicitudApi = this.crearSolicitud()
      if (this.datos.pagina === undefined) {
        pagina = 0
      }
      this.loading = true
      var datos = {
        tipo: 'lista',
        nfilas: this.pagination.rowsPerPage,
        idx: idx,
        ord: ord,
        pag: pagina
      }
      solicitudApi.datos = datos
      const myRequest = new Request(`${process.env.NODE_API}deposito/listar`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            this.datos = datos.d
            this.totalRegistros = this.datos.registros
            if (parseInt(this.datos.pagina) !== parseInt(this.pagination.page)) {
              this.pagination.page = parseInt(this.datos.pagina)
            }
            this.productos = this.datos.productos
            this.loading = false
          }
        })
    },
    verRegistro (item) {
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = []
      const myRequest = new Request(`${process.env.NODE_API}deposito/ver/id/` + item.id, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            this.registro = datos.d.registro
            this.errores = datos.d.errores
            if (item.id !== 0) {
              this.disabledRegistro = true
            } else {
              this.disabledRegistro = false
            }
            this.dialog = true
          }
        })
    },
    nuevoRegistro () {
      this.verRegistro({id: 0})
    },
    cerrar () {
      this.dialog = false
      setTimeout(() => {
      }, 300)
    },
    guardar (id) {
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = this.registro
      const myRequest = new Request(`${process.env.NODE_API}deposito/guardar/id/` + id, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            if (datos.e === 1) {
              this.verRegistro(datos.d)
              let descendente = 0
              if (this.pagination.descending) {
                descendente = 1
              }
              this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page)
              this.cerrar()
            } else {
              this.errores = datos.d.errores
            }
          }
        })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Depositos.vue